export class NorthwindMetadata {
    public static value = {
  "structuralTypes": [
    {
      "shortName": "ApplicationUser",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "None",
      "defaultResourceName": "Users",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "String",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "Id",
          "validators": [{ "name": "required" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "AccessFailedCount",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "Color",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "concurrencyMode": "Fixed",
          "nameOnServer": "ConcurrencyStamp",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "maxLength": 256,
          "nameOnServer": "Email",
          "validators": [{ "maxLength": 256, "name": "maxLength" }]
        },
        {
          "dataType": "Boolean",
          "isNullable": false,
          "nameOnServer": "EmailConfirmed",
          "validators": [{ "name": "required" }, { "name": "bool" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "FirstName",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "FullName",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "LastName",
          "validators": []
        },
        {
          "dataType": "Boolean",
          "isNullable": false,
          "nameOnServer": "LockoutEnabled",
          "validators": [{ "name": "required" }, { "name": "bool" }]
        },
        {
          "dataType": "DateTimeOffset",
          "isNullable": true,
          "nameOnServer": "LockoutEnd",
          "validators": [{ "name": "date" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "maxLength": 256,
          "nameOnServer": "NormalizedEmail",
          "validators": [{ "maxLength": 256, "name": "maxLength" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "maxLength": 256,
          "nameOnServer": "NormalizedUserName",
          "validators": [{ "maxLength": 256, "name": "maxLength" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "PasswordHash",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "PhoneNumber",
          "validators": []
        },
        {
          "dataType": "Boolean",
          "isNullable": false,
          "nameOnServer": "PhoneNumberConfirmed",
          "validators": [{ "name": "required" }, { "name": "bool" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "SecurityStamp",
          "validators": []
        },
        {
          "dataType": "Boolean",
          "isNullable": false,
          "nameOnServer": "TwoFactorEnabled",
          "validators": [{ "name": "required" }, { "name": "bool" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "maxLength": 256,
          "nameOnServer": "UserName",
          "validators": [{ "maxLength": 256, "name": "maxLength" }]
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "Customer:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Customer_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "invForeignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "Customers",
          "validators": []
        },
        {
          "entityTypeName": "EquipmentAttachment:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.EquipmentAttachment_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "invForeignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "EquipmentAttachments",
          "validators": []
        },
        {
          "entityTypeName": "EquipmentStatus:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.EquipmentStatus_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "invForeignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "EquipmentStatuses",
          "validators": []
        },
        {
          "entityTypeName": "Equipment:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "invForeignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "Equipments",
          "validators": []
        },
        {
          "entityTypeName": "Expense:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Expense_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "invForeignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "Expenses",
          "validators": []
        },
        {
          "entityTypeName": "PurchaseTransaction:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.PurchaseTransaction_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "invForeignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "PurchaseTransactions",
          "validators": []
        },
        {
          "entityTypeName": "SalesTransaction:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.SalesTransaction_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "invForeignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "SalesTransactions",
          "validators": []
        },
        {
          "entityTypeName": "Supplier:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Supplier_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "invForeignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "Suppliers",
          "validators": []
        },
        {
          "entityTypeName": "TransactionType:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.TransactionType_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "invForeignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "TransactionTypes",
          "validators": []
        }
      ]
    },
    {
      "shortName": "Brand",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "Brands",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "BrandId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "BrandName",
          "validators": []
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "EquipmentModel:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.EquipmentModel_BestWay.Core.Models.Brand_Brand",
          "invForeignKeyNamesOnServer": ["BrandId"],
          "nameOnServer": "EquipmentModels",
          "validators": []
        },
        {
          "entityTypeName": "Equipment:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.Brand_Brand",
          "invForeignKeyNamesOnServer": ["BrandId"],
          "nameOnServer": "Equipments",
          "validators": []
        }
      ]
    },
    {
      "shortName": "Category",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "Categories",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "CategoryId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "CategoryName",
          "validators": []
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "Equipment:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.Category_Category",
          "invForeignKeyNamesOnServer": ["CategoryId"],
          "nameOnServer": "Equipments",
          "validators": []
        }
      ]
    },
    {
      "shortName": "Country",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "Countries",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "CountryId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "CountryName",
          "validators": []
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "Customer:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Customer_BestWay.Core.Models.Country_Country",
          "invForeignKeyNamesOnServer": ["CountryId"],
          "nameOnServer": "Customers",
          "validators": []
        },
        {
          "entityTypeName": "Equipment:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.Country_Country",
          "invForeignKeyNamesOnServer": ["CountryId"],
          "nameOnServer": "Equipments",
          "validators": []
        },
        {
          "entityTypeName": "Supplier:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Supplier_BestWay.Core.Models.Country_Country",
          "invForeignKeyNamesOnServer": ["CountryId"],
          "nameOnServer": "Suppliers",
          "validators": []
        }
      ]
    },
    {
      "shortName": "Customer",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "Customers",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "CustomerId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ApplicationUserId",
          "validators": []
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "CountryId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "CreatedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "CustomerLoctaion",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "CustomerMobile",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "CustomerName",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "CustomerPhone",
          "validators": []
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "ModifiedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "Website",
          "validators": []
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "ApplicationUser:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Customer_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "foreignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "ApplicationUser",
          "validators": []
        },
        {
          "entityTypeName": "Country:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Customer_BestWay.Core.Models.Country_Country",
          "foreignKeyNamesOnServer": ["CountryId"],
          "nameOnServer": "Country",
          "validators": []
        },
        {
          "entityTypeName": "Equipment:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.Customer_Customer",
          "invForeignKeyNamesOnServer": ["CustomerId"],
          "nameOnServer": "Equipments",
          "validators": []
        },
        {
          "entityTypeName": "SalesTransaction:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.SalesTransaction_BestWay.Core.Models.Customer_Customer",
          "invForeignKeyNamesOnServer": ["CustomerId"],
          "nameOnServer": "SalesTransactions",
          "validators": []
        }
      ]
    },
    {
      "shortName": "Equipment",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "Equipments",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "EquipmentId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ApplicationUserId",
          "validators": []
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "BrandId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "CategoryId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "CountryId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "CreatedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "CustomerId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "Description",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "EqiupmentName",
          "validators": []
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "EquipmentModelId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "EquipmentStatusId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Decimal",
          "isNullable": false,
          "nameOnServer": "ExchangeRate",
          "validators": [{ "name": "required" }, { "name": "number" }]
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "ModifiedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        },
        {
          "dataType": "Decimal",
          "isNullable": false,
          "nameOnServer": "PurchasingPrice",
          "validators": [{ "name": "required" }, { "name": "number" }]
        },
        {
          "dataType": "Decimal",
          "isNullable": false,
          "nameOnServer": "SalesPrice",
          "validators": [{ "name": "required" }, { "name": "number" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "SupplierId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Decimal",
          "isNullable": false,
          "nameOnServer": "TotalExpense",
          "validators": [{ "name": "required" }, { "name": "number" }]
        },
        {
          "dataType": "Decimal",
          "isNullable": false,
          "nameOnServer": "Weight",
          "validators": [{ "name": "required" }, { "name": "number" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "WorkingHours",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "YearMake",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "ApplicationUser:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "foreignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "ApplicationUser",
          "validators": []
        },
        {
          "entityTypeName": "Brand:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.Brand_Brand",
          "foreignKeyNamesOnServer": ["BrandId"],
          "nameOnServer": "Brand",
          "validators": []
        },
        {
          "entityTypeName": "Category:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.Category_Category",
          "foreignKeyNamesOnServer": ["CategoryId"],
          "nameOnServer": "Category",
          "validators": []
        },
        {
          "entityTypeName": "Country:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.Country_Country",
          "foreignKeyNamesOnServer": ["CountryId"],
          "nameOnServer": "Country",
          "validators": []
        },
        {
          "entityTypeName": "Customer:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.Customer_Customer",
          "foreignKeyNamesOnServer": ["CustomerId"],
          "nameOnServer": "Customer",
          "validators": []
        },
        {
          "entityTypeName": "EquipmentAttachment:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.EquipmentAttachment_BestWay.Core.Models.Equipment_Equipment",
          "invForeignKeyNamesOnServer": ["EquipmentId"],
          "nameOnServer": "EquipmentAttachments",
          "validators": []
        },
        {
          "entityTypeName": "EquipmentImage:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.EquipmentImage_BestWay.Core.Models.Equipment_Equipment",
          "invForeignKeyNamesOnServer": ["EquipmentId"],
          "nameOnServer": "EquipmentImages",
          "validators": []
        },
        {
          "entityTypeName": "EquipmentModel:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.EquipmentModel_EquipmentModel",
          "foreignKeyNamesOnServer": ["EquipmentModelId"],
          "nameOnServer": "EquipmentModel",
          "validators": []
        },
        {
          "entityTypeName": "EquipmentStatus:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.EquipmentStatus_EquipmentStatus",
          "foreignKeyNamesOnServer": ["EquipmentStatusId"],
          "nameOnServer": "EquipmentStatus",
          "validators": []
        },
        {
          "entityTypeName": "Supplier:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.Supplier_Supplier",
          "foreignKeyNamesOnServer": ["SupplierId"],
          "nameOnServer": "Supplier",
          "validators": []
        }
      ]
    },
    {
      "shortName": "EquipmentAttachment",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "EquipmentAttachments",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "EquipmentAttachmentId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ApplicationUserId",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "AttName",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "AttRef",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "AttachmentUrl",
          "validators": []
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "CreatedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "EquipmentAttachmentTypeId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "EquipmentId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "ModifiedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "ApplicationUser:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.EquipmentAttachment_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "foreignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "ApplicationUser",
          "validators": []
        },
        {
          "entityTypeName": "Equipment:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.EquipmentAttachment_BestWay.Core.Models.Equipment_Equipment",
          "foreignKeyNamesOnServer": ["EquipmentId"],
          "nameOnServer": "Equipment",
          "validators": []
        },
        {
          "entityTypeName": "EquipmentAttachmentType:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.EquipmentAttachment_BestWay.Core.Models.EquipmentAttachmentType_EquipmentAttachmentType",
          "foreignKeyNamesOnServer": ["EquipmentAttachmentTypeId"],
          "nameOnServer": "EquipmentAttachmentType",
          "validators": []
        }
      ]
    },
    {
      "shortName": "EquipmentAttachmentType",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "EquipmentAttachmentTypes",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "EquipmentAttachmentTypeId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "AttTypeName",
          "validators": []
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "EquipmentAttachment:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.EquipmentAttachment_BestWay.Core.Models.EquipmentAttachmentType_EquipmentAttachmentType",
          "invForeignKeyNamesOnServer": ["EquipmentAttachmentTypeId"],
          "nameOnServer": "EquipmentAttachments",
          "validators": []
        }
      ]
    },
    {
      "shortName": "EquipmentImage",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "EquipmentImages",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "EquipmentImageId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "EquipmentId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ImageName",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ImageUrl",
          "validators": []
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "Equipment:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.EquipmentImage_BestWay.Core.Models.Equipment_Equipment",
          "foreignKeyNamesOnServer": ["EquipmentId"],
          "nameOnServer": "Equipment",
          "validators": []
        }
      ]
    },
    {
      "shortName": "EquipmentModel",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "EquipmentModels",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "EquipmentModelId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "BrandId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ModelName",
          "validators": []
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "Brand:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.EquipmentModel_BestWay.Core.Models.Brand_Brand",
          "foreignKeyNamesOnServer": ["BrandId"],
          "nameOnServer": "Brand",
          "validators": []
        },
        {
          "entityTypeName": "Equipment:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.EquipmentModel_EquipmentModel",
          "invForeignKeyNamesOnServer": ["EquipmentModelId"],
          "nameOnServer": "Equipments",
          "validators": []
        }
      ]
    },
    {
      "shortName": "EquipmentStatus",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "EquipmentStatuses",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "EquipmentStatusId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ApplicationUserId",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "StatusName",
          "validators": []
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "ApplicationUser:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.EquipmentStatus_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "foreignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "ApplicationUser",
          "validators": []
        },
        {
          "entityTypeName": "Equipment:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.EquipmentStatus_EquipmentStatus",
          "invForeignKeyNamesOnServer": ["EquipmentStatusId"],
          "nameOnServer": "Equipments",
          "validators": []
        }
      ]
    },
    {
      "shortName": "Expense",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "Expenses",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "ExpenseId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ApplicationUserId",
          "validators": []
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "CreatedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "Description",
          "validators": []
        },
        {
          "dataType": "Int32",
          "isNullable": true,
          "nameOnServer": "EquipmentId",
          "validators": [{ "name": "int32" }]
        },
        {
          "dataType": "Decimal",
          "isNullable": false,
          "nameOnServer": "ExchangeRate",
          "validators": [{ "name": "required" }, { "name": "number" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ExpenseName",
          "validators": []
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "ExpenseTypeId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Decimal",
          "isNullable": false,
          "nameOnServer": "ExpenseValue",
          "validators": [{ "name": "required" }, { "name": "number" }]
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "ModifiedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "ApplicationUser:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Expense_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "foreignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "ApplicationUser",
          "validators": []
        },
        {
          "entityTypeName": "Equipment:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Expense_BestWay.Core.Models.Equipment_Equipment",
          "foreignKeyNamesOnServer": ["EquipmentId"],
          "nameOnServer": "Equipment",
          "validators": []
        },
        {
          "entityTypeName": "ExpenseType:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Expense_BestWay.Core.Models.ExpenseType_ExpenseType",
          "foreignKeyNamesOnServer": ["ExpenseTypeId"],
          "nameOnServer": "ExpenseType",
          "validators": []
        }
      ]
    },
    {
      "shortName": "ExpenseType",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "ExpenseTypes",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "ExpenseTypeId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ExpenseTypeName",
          "validators": []
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "Expense:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Expense_BestWay.Core.Models.ExpenseType_ExpenseType",
          "invForeignKeyNamesOnServer": ["ExpenseTypeId"],
          "nameOnServer": "Expenses",
          "validators": []
        }
      ]
    },
    {
      "shortName": "PurchaseTransaction",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "PurchaseTransactions",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "PurchaseTransactionId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Decimal",
          "isNullable": false,
          "nameOnServer": "Amount",
          "validators": [{ "name": "required" }, { "name": "number" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ApplicationUserId",
          "validators": []
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "CreatedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "Description",
          "validators": []
        },
        {
          "dataType": "Decimal",
          "isNullable": false,
          "nameOnServer": "ExchangeRate",
          "validators": [{ "name": "required" }, { "name": "number" }]
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "ModifiedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "SupplierId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "TransactionTypeId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "ValueDate",
          "validators": [{ "name": "required" }, { "name": "date" }]
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "ApplicationUser:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.PurchaseTransaction_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "foreignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "ApplicationUser",
          "validators": []
        },
        {
          "entityTypeName": "Supplier:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.PurchaseTransaction_BestWay.Core.Models.Supplier_Supplier",
          "foreignKeyNamesOnServer": ["SupplierId"],
          "nameOnServer": "Supplier",
          "validators": []
        },
        {
          "entityTypeName": "TransactionType:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.PurchaseTransaction_BestWay.Core.Models.TransactionType_TransactionType",
          "foreignKeyNamesOnServer": ["TransactionTypeId"],
          "nameOnServer": "TransactionType",
          "validators": []
        }
      ]
    },
    {
      "shortName": "SalesTransaction",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "SalesTransactions",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "SalesTransactionId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "Decimal",
          "isNullable": false,
          "nameOnServer": "Amount",
          "validators": [{ "name": "required" }, { "name": "number" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ApplicationUserId",
          "validators": []
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "CreatedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "CustomerId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "Description",
          "validators": []
        },
        {
          "dataType": "Decimal",
          "isNullable": false,
          "nameOnServer": "ExchangeRate",
          "validators": [{ "name": "required" }, { "name": "number" }]
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "ModifiedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "TransactionTypeId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "ValueDate",
          "validators": [{ "name": "required" }, { "name": "date" }]
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "ApplicationUser:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.SalesTransaction_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "foreignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "ApplicationUser",
          "validators": []
        },
        {
          "entityTypeName": "Customer:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.SalesTransaction_BestWay.Core.Models.Customer_Customer",
          "foreignKeyNamesOnServer": ["CustomerId"],
          "nameOnServer": "Customer",
          "validators": []
        },
        {
          "entityTypeName": "TransactionType:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.SalesTransaction_BestWay.Core.Models.TransactionType_TransactionType",
          "foreignKeyNamesOnServer": ["TransactionTypeId"],
          "nameOnServer": "TransactionType",
          "validators": []
        }
      ]
    },
    {
      "shortName": "Supplier",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "Suppliers",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "SupplierId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "AirCode",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ApplicationUserId",
          "validators": []
        },
        {
          "dataType": "Int32",
          "isNullable": false,
          "nameOnServer": "CountryId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "CreatedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        },
        {
          "dataType": "DateTime",
          "isNullable": false,
          "nameOnServer": "ModifiedOn",
          "validators": [{ "name": "required" }, { "name": "date" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "SupplierLocation",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "SupplierMobile",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "SupplierName",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "SupplierPhone",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "Website",
          "validators": []
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "ApplicationUser:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Supplier_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "foreignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "ApplicationUser",
          "validators": []
        },
        {
          "entityTypeName": "Country:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.Supplier_BestWay.Core.Models.Country_Country",
          "foreignKeyNamesOnServer": ["CountryId"],
          "nameOnServer": "Country",
          "validators": []
        },
        {
          "entityTypeName": "Equipment:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.Equipment_BestWay.Core.Models.Supplier_Supplier",
          "invForeignKeyNamesOnServer": ["SupplierId"],
          "nameOnServer": "Equipments",
          "validators": []
        },
        {
          "entityTypeName": "PurchaseTransaction:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.PurchaseTransaction_BestWay.Core.Models.Supplier_Supplier",
          "invForeignKeyNamesOnServer": ["SupplierId"],
          "nameOnServer": "PurchaseTransactions",
          "validators": []
        }
      ]
    },
    {
      "shortName": "TransactionType",
      "namespace": "BestWay.Core.Models",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "TransactionTypes",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "TransactionTypeId",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ApplicationUserId",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "Name",
          "validators": []
        }
      ],
      "navigationProperties": [
        {
          "entityTypeName": "ApplicationUser:#BestWay.Core.Models",
          "isScalar": true,
          "associationName": "BestWay.Core.Models.TransactionType_BestWay.Core.Models.ApplicationUser_ApplicationUser",
          "foreignKeyNamesOnServer": ["ApplicationUserId"],
          "nameOnServer": "ApplicationUser",
          "validators": []
        },
        {
          "entityTypeName": "PurchaseTransaction:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.PurchaseTransaction_BestWay.Core.Models.TransactionType_TransactionType",
          "invForeignKeyNamesOnServer": ["TransactionTypeId"],
          "nameOnServer": "PurchaseTransactions",
          "validators": []
        },
        {
          "entityTypeName": "SalesTransaction:#BestWay.Core.Models",
          "isScalar": false,
          "associationName": "BestWay.Core.Models.SalesTransaction_BestWay.Core.Models.TransactionType_TransactionType",
          "invForeignKeyNamesOnServer": ["TransactionTypeId"],
          "nameOnServer": "SalesTransactions",
          "validators": []
        }
      ]
    },
    {
      "shortName": "IdentityRole",
      "namespace": "Microsoft.AspNetCore.Identity",
      "autoGeneratedKeyType": "None",
      "defaultResourceName": "Roles",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "String",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "Id",
          "validators": [{ "name": "required" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "concurrencyMode": "Fixed",
          "nameOnServer": "ConcurrencyStamp",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "maxLength": 256,
          "nameOnServer": "Name",
          "validators": [{ "maxLength": 256, "name": "maxLength" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "maxLength": 256,
          "nameOnServer": "NormalizedName",
          "validators": [{ "maxLength": 256, "name": "maxLength" }]
        }
      ],
      "navigationProperties": []
    },
    {
      "shortName": "IdentityRoleClaim",
      "namespace": "Microsoft.AspNetCore.Identity",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "RoleClaims",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "Id",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ClaimType",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ClaimValue",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": false,
          "nameOnServer": "RoleId",
          "validators": [{ "name": "required" }]
        }
      ],
      "navigationProperties": []
    },
    {
      "shortName": "IdentityUserClaim",
      "namespace": "Microsoft.AspNetCore.Identity",
      "autoGeneratedKeyType": "Identity",
      "defaultResourceName": "UserClaims",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "Int32",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "Id",
          "validators": [{ "name": "required" }, { "name": "int32" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ClaimType",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ClaimValue",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": false,
          "nameOnServer": "UserId",
          "validators": [{ "name": "required" }]
        }
      ],
      "navigationProperties": []
    },
    {
      "shortName": "IdentityUserLogin",
      "namespace": "Microsoft.AspNetCore.Identity",
      "autoGeneratedKeyType": "None",
      "defaultResourceName": "UserLogins",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "String",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "LoginProvider",
          "validators": [{ "name": "required" }]
        },
        {
          "dataType": "String",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "ProviderKey",
          "validators": [{ "name": "required" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "ProviderDisplayName",
          "validators": []
        },
        {
          "dataType": "String",
          "isNullable": false,
          "nameOnServer": "UserId",
          "validators": [{ "name": "required" }]
        }
      ],
      "navigationProperties": []
    },
    {
      "shortName": "IdentityUserRole",
      "namespace": "Microsoft.AspNetCore.Identity",
      "autoGeneratedKeyType": "None",
      "defaultResourceName": "UserRoles",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "String",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "UserId",
          "validators": [{ "name": "required" }]
        },
        {
          "dataType": "String",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "RoleId",
          "validators": [{ "name": "required" }]
        }
      ],
      "navigationProperties": []
    },
    {
      "shortName": "IdentityUserToken",
      "namespace": "Microsoft.AspNetCore.Identity",
      "autoGeneratedKeyType": "None",
      "defaultResourceName": "UserTokens",
      "isComplexType": false,
      "dataProperties": [
        {
          "dataType": "String",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "UserId",
          "validators": [{ "name": "required" }]
        },
        {
          "dataType": "String",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "LoginProvider",
          "validators": [{ "name": "required" }]
        },
        {
          "dataType": "String",
          "isPartOfKey": true,
          "isNullable": false,
          "nameOnServer": "Name",
          "validators": [{ "name": "required" }]
        },
        {
          "dataType": "String",
          "isNullable": true,
          "nameOnServer": "Value",
          "validators": []
        }
      ],
      "navigationProperties": []
    }
  ]
}
;
}